ACC.searchmanageusers = {
  freeTextInputClass: '.ph-manageusers__freetextsearch--input',
  freeTextNoResultClass: '.ph-manageusers__freeTextSearch--noResultsMain',
  pageInitiatedClass: '.ph-oneStore__freeTextSearch--initialData',
  dataInitiatedAttribute: 'data-initiated',
  manageUsersAllDataWrapperClass: '.ph-manageusers__alldata--wrapper',
  intersectionObserverClass: '.ph-intersection-observer',

  setObserverSearchManageUsers: function(markInstance) {
    var container = document.querySelector(ACC.searchmanageusers.intersectionObserverClass),
        newMarkInstance = markInstance;

    function intersection() {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var isIntersecting = entry.isIntersecting;

          if (isIntersecting) {
            ACC.searchmanageusers.loadContentSmartlySearchManageUsers(container, observer, newMarkInstance);
            observer.observe(container);
          }

          return true;
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0
        });
      });

      observer.observe(container);
    }

    if ('IntersectionObserver' in window) {
      intersection();
    } else {
      $.getScript(ACC.config.commonResourcePath + '/philipsUI/src/js/vendor/intersection-observer.min.js', function() {
        intersection();
      });
    }
  },

  loadContentSmartlySearchManageUsers: function(container, observer, markInstance) {
    var pageLength = $('.ph-mycompany__usersrow').length / 5,
        numberOfPages = parseInt($(ACC.searchmanageusers.pageInitiatedClass).attr('data-pagenumber'), 10),
        pageLengths = Math.ceil(pageLength),
        initiated = parseInt($(ACC.searchmanageusers.pageInitiatedClass).attr(ACC.searchmanageusers.dataInitiatedAttribute), 10),
        newMarkInstance = markInstance,
        freeSearchLength = $('.ph-manageUsers__freeSearch').length;

    if (freeSearchLength === 1) {
      if ((initiated < pageLengths) && (pageLengths < numberOfPages)) {
        $(ACC.searchmanageusers.pageInitiatedClass).attr(ACC.searchmanageusers.dataInitiatedAttribute, pageLengths);
        ACC.searchmanageusers.freeSearchAjax(pageLengths, newMarkInstance);
      }

      if (pageLengths >= numberOfPages) {
        $(ACC.searchmanageusers.intersectionObserverClass).hide();
      } else if ($(ACC.searchmanageusers.freeTextNoResultClass).hasClass('hidden')) {
        $(ACC.searchmanageusers.intersectionObserverClass).show();
      }

      observer.unobserve(container);
    }
  },

  freeSearchAjax: function(pageLengthsVal, markInstance) {
    var newMarkInstance = markInstance,
        sortValue = $('.ph-sortoptions').val(),
        pageLengths = pageLengthsVal,
        freeTextSearchInputValue = $(ACC.searchmanageusers.freeTextInputClass).val();

    if (freeTextSearchInputValue) {
      if (sortValue === 'byName') {
        sortValue = 'name';
      } else if (sortValue === 'byStatus') {
        sortValue = 'active';
      }

      $.ajax({
        url: ACC.config.contextPath + 'manage-users/search-manage-users.json',
        type: 'GET',
        dataType: 'json',
        data: {
          text: freeTextSearchInputValue,
          sort: sortValue,
          page: pageLengths
        },
        success: function(data) {
          if (data) {
            if (data.results && data.pagination) {
              $(ACC.searchmanageusers.pageInitiatedClass).attr(ACC.searchmanageusers.dataInitiatedAttribute, pageLengths);
              $(ACC.searchmanageusers.pageInitiatedClass).attr('data-pagenumber', data.pagination.numberOfPages);
              ACC.manageusers.creatingRows(data);
              ACC.searchmanageusers.markSearchedTextMain(newMarkInstance, freeTextSearchInputValue);
            } else {
              ACC.searchmanageusers.freeTextNoResult(freeTextSearchInputValue);
            }
          } else {
            $(ACC.searchmanageusers.manageUsersAllDataWrapperClass).html('');
            ACC.searchmanageusers.freeTextNoResult(freeTextSearchInputValue);
          }
        },
        error: function() {
          $(ACC.searchmanageusers.manageUsersAllDataWrapperClass).html('');
          ACC.searchmanageusers.freeTextNoResult(freeTextSearchInputValue);
        }
      });
    } else {
      $(ACC.searchmanageusers.manageUsersAllDataWrapperClass).removeClass('ph-manageUsers__freeSearch');
      ACC.manageusers.setObserverUser();
    }
  },

  markSearchedTextMain: function(markInstance, freeTextSearchInputValue) {
    var newMarkInstance = markInstance;

    if (freeTextSearchInputValue) {
      $(ACC.searchmanageusers.freeTextNoResultClass).addClass('hidden');
      ACC.searchmanageusers.markSearchedText(newMarkInstance, freeTextSearchInputValue);
    }
  },

  markSearchedText: function(markInstance, freeTextSearchInputValue) {
    var newMarkInstance = markInstance;

    newMarkInstance.mark(freeTextSearchInputValue, {
      caseSensitive: false,
      separateWordSearch: true,
      exclude: ['button'],
      done: function(mark) {
        if (mark) {
          $(ACC.searchmanageusers.freeTextNoResultClass).addClass('hidden');
          $('.ph-mycompany__usersrow').each(function() {
            if ($(this).find('mark').length > 0) {
              $(this).show();
            }
          });
        }
      }
    });
  },

  freeTextNoResult: function(freeTextSearchInputValue) {
    if (freeTextSearchInputValue) {
      $(ACC.searchmanageusers.freeTextNoResultClass).removeClass('hidden');
      $('.ph-manageusers__freeTextSearch--noResults').html(' ' + freeTextSearchInputValue);
      $(ACC.searchmanageusers.intersectionObserverClass).hide();
    }
  }
};

(function() {
  $('.ph-manageusers__freetextsearch--tooltipicon').on('click', function() {
    $('.ph-manageusers__freetextsearch--tooltiptext').toggleClass('hidden');
  });
})();
